/* Rivendel — interacciones de tarjeta: quick-add al carrito + toast. */
(function () {
  function toast(msg, isError) {
    var el = document.querySelector('.rv-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'rv-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    var ok = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12l5 5L20 7"/></svg>';
    el.innerHTML = (isError ? '' : ok) + '<span></span>';
    el.querySelector('span').textContent = msg;
    clearTimeout(el._t);
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    el._t = setTimeout(function () { el.classList.remove('is-on'); }, 3200);
  }

  // Abrir/cerrar panel de tallas (si se usa)
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-rv-qa-toggle]');
    if (!t) return;
    e.preventDefault();
    var qa = t.closest('[data-rv-qa]');
    var open = qa.hasAttribute('data-open');
    if (open) { qa.removeAttribute('data-open'); t.setAttribute('aria-expanded', 'false'); }
    else { qa.setAttribute('data-open', ''); t.setAttribute('aria-expanded', 'true'); }
  });

  // Añadir al carrito
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rv-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-busy')) return;
    var id = btn.getAttribute('data-rv-add');
    btn.classList.add('is-busy');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'rv-quick-add', data: { source: 'rv-quick-add', itemCount: cart.item_count } }
        }));
        var qa = btn.closest('[data-rv-qa]');
        if (qa) qa.removeAttribute('data-open');
        toast('Añadido a la cesta');
      })
      .catch(function () { toast('No se pudo añadir', true); })
      .finally(function () { btn.classList.remove('is-busy'); });
  });

  /* ---------- Comprados juntamente (FBT) ---------- */
  function fmtEUR(cents) {
    var n = (cents / 100).toFixed(2).replace('.', ',');
    return n.replace(/\B(?=(\d{3})+(?!\d),)/g, '.') + '€';
  }
  function recalcBundle(b) {
    if (!b) return [];
    var total = 0, ids = [];
    b.querySelectorAll('[data-rv-bundle-item]').forEach(function (cb) {
      if (cb.checked) { total += parseInt(cb.getAttribute('data-price'), 10) || 0; ids.push(cb.getAttribute('data-variant')); }
    });
    var t = b.querySelector('[data-rv-bundle-total]');
    if (t) t.textContent = fmtEUR(total);
    var add = b.querySelector('[data-rv-bundle-add]');
    if (add) add.disabled = ids.length === 0;
    return ids;
  }
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-rv-bundle-item]');
    if (!cb) return;
    recalcBundle(cb.closest('[data-rv-bundle]'));
  });
  /* ---------- Color → swatches HEX (re-skin del picker nativo) ---------- */
  var RV_COLORS = {
    'black': '#1b1b1b', 'negro': '#1b1b1b', 'noir': '#1b1b1b',
    'white': '#f1efe9', 'blanco': '#f1efe9', 'blanc': '#f1efe9', 'optic white': '#f4f2ec',
    'cloud white': '#f1efe9', 'off white': '#efece3', 'crudo': '#efece3', 'ecru': '#e7ddc9',
    'grey': '#7d7f83', 'gray': '#7d7f83', 'gris': '#7d7f83', 'marengo': '#5c5e62',
    'charcoal': '#3f4145', 'antracita': '#3f4145',
    'navy': '#1f2a44', 'marino': '#1f2a44', 'azul marino': '#1f2a44', 'marine': '#1f2a44',
    'blue': '#3a5a86', 'azul': '#3a5a86', 'celeste': '#7ea3c8',
    'green': '#3a5a40', 'verde': '#3a5a40', 'bottle': '#26392b', 'botella': '#26392b',
    'olive': '#6b6a45', 'oliva': '#6b6a45', 'khaki': '#6b6a45', 'kaki': '#6b6a45', 'militar': '#5a5a3a',
    'red': '#8c2b2b', 'rojo': '#8c2b2b', 'wine': '#5a1f2a', 'vino': '#5a1f2a',
    'burgundy': '#5a1f2a', 'burdeos': '#5a1f2a', 'granate': '#5a1f2a', 'black cherry': '#3f1c22',
    'beige': '#c8b69a', 'sand': '#c8b69a', 'arena': '#c8b69a', 'camel': '#b8916a', 'tan': '#b8916a',
    'stone': '#c4bbac', 'piedra': '#c4bbac',
    'brown': '#5a3f2b', 'marron': '#5a3f2b', 'chocolate': '#3f2a1c',
    'cream': '#e7ddc9', 'crema': '#e7ddc9', 'hueso': '#ece5d6', 'vainilla': '#ece0c4',
    'yellow': '#caa23c', 'amarillo': '#caa23c', 'mustard': '#c19a2e', 'mostaza': '#c19a2e',
    'orange': '#c4622d', 'naranja': '#c4622d',
    'pink': '#d8a0a6', 'rosa': '#d8a0a6', 'rosado': '#d8a0a6',
    'purple': '#5d4777', 'morado': '#5d4777', 'lila': '#9b86b8', 'violeta': '#5d4777'
  };
  function hexOf(name) {
    var n = name.toLowerCase().trim();
    if (RV_COLORS[n]) return RV_COLORS[n];
    var first = n.split(/[\s\/-]+/)[0];
    return RV_COLORS[first] || null;
  }
  function colorBg(name) {
    var n = name.toLowerCase().trim();
    if (RV_COLORS[n]) return RV_COLORS[n];
    if (n.indexOf('/') > -1) {
      var p = n.split('/');
      var a = hexOf(p[0]); var b = hexOf(p[1]);
      if (a && b) return 'linear-gradient(135deg,' + a + ' 0 50%,' + b + ' 50% 100%)';
      if (a) return a;
    }
    return hexOf(n);
  }
  function enhanceVariants(root) {
    (root || document).querySelectorAll('.variant-option').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend) return;
      var name = legend.textContent.toLowerCase();
      if (/colou?r/.test(name) && !fs.classList.contains('rv-color')) {
        var labels = fs.querySelectorAll('.variant-option__button-label');
        var bgs = [];
        var ok = labels.length > 0;
        labels.forEach(function (lab) {
          var inp = lab.querySelector('input');
          var bg = inp ? colorBg(inp.value) : null;
          bgs.push(bg);
          if (!bg) ok = false;
        });
        if (!ok) return; // si algún color no mapea, dejar botones (sin medias tintas)
        fs.classList.add('rv-color');
        labels.forEach(function (lab, i) {
          lab.style.setProperty('--rv-hex', bgs[i]);
          var inp = lab.querySelector('input');
          if (inp) lab.setAttribute('title', inp.value);
        });
      } else if (/tall|size|n[uú]mero/.test(name)) {
        fs.classList.add('rv-size');
      }
    });
  }
  function bootVariants() { enhanceVariants(document); }
  if (document.readyState !== 'loading') bootVariants();
  else document.addEventListener('DOMContentLoaded', bootVariants);
  document.addEventListener('shopify:section:load', function (e) { enhanceVariants(e.target); });
  // reaplica si el picker se re-renderiza (listados combinados)
  document.addEventListener('variant:update', function () { setTimeout(bootVariants, 30); });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rv-bundle-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-busy')) return;
    var b = btn.closest('[data-rv-bundle]');
    var ids = recalcBundle(b);
    if (!ids.length) return;
    btn.classList.add('is-busy');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'rv-bundle', data: { source: 'rv-bundle', itemCount: cart.item_count } }
        }));
        toast('Añadido a la cesta');
      })
      .catch(function () { toast('No se pudo añadir', true); })
      .finally(function () { btn.classList.remove('is-busy'); });
  });
})();
